import React from "react";
import PropTypes from "prop-types";
// Constants
import * as FORM_CONST from "../../../constants/formComponents";
// Styles
import "./TextArea.css";
import classNames from "classnames";

const TextArea = ({
  className = "",
  disabled = false,
  label,
  onChange,
  placeholder = FORM_CONST.PLACEHOLDER_DEFAULT,
  required = false,
  style,
  value,
  wrapperClassName,
  ...additionalProps
}) => {
  const labelClasses = classNames("textarea__label-name", {
    "admin__disabled-color": disabled,
  });

  const textareaClasses = classNames(
    "textarea__box",
    {
      "admin__disabled-color admin__disabled-background user__disabled-background":
        disabled,
    },
    {
      "textarea__box-default": !className,
    }
  );

  return (
    <div className={wrapperClassName}>
      {label && (
        <label className={labelClasses}>
          {label}
          {required ? "*" : null}
        </label>
      )}
      <textarea
        className={textareaClasses}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        style={style}
        type="text"
        value={value}
        {...additionalProps}
      />
    </div>
  );
};

TextArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

export default TextArea;
